function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers, JSON, Object, String, alert, alertId, displayContext, isRead, message) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['alert-content'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-sh-alert-header': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": Object.assign({}, {
              'mp-sh-alert-type-anomaly': !!alert.anomaly,
              'mp-sh-alert-type-contour': !!alert.contour,
            }, {
              'mp-sh-alert-type-icon': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(($helpers.getAlertDirection() === `NEGATIVE`) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h('div', {
                props: {
                  innerHTML: '<?xml version="1.0" encoding="UTF-8"?><svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">   <title>Arrow Down</title>    <desc>Smart Hub Icons</desc>    <defs></defs>    <g id="Arrow Down" stroke="none" stroke-width="1" fill-rule="evenodd">        <g id="Arrow-Down">            <g id="Page-1" transform="translate(8.000000, 8.000000) rotate(180.000000) translate(-8.000000, -8.000000) ">                <path d="M8,0 C12.418,0 16,3.582 16,8 C16,12.418 12.418,16 8,16 C3.582,16 0,12.418 0,8 C0,3.582 3.582,0 8,0" id="disc"></path>                <path d="M10.9121,7.3394 L8.4241,4.9214 C8.1901,4.6934 7.8101,4.6934 7.5761,4.9214 L5.0881,7.3394 C4.9711,7.4534 4.9711,7.6384 5.0881,7.7524 L5.5121,8.1644 C5.6291,8.2774 5.8191,8.2774 5.9361,8.1644 L7.4001,6.7414 L7.4001,11.4584 C7.4001,11.6194 7.5341,11.7504 7.7001,11.7504 L8.3001,11.7504 C8.4661,11.7504 8.5991,11.6194 8.5991,11.4584 L8.5991,6.7414 L10.0631,8.1644 C10.1811,8.2774 10.3711,8.2774 10.4881,8.1644 L10.9121,7.7524 C11.0291,7.6384 11.0291,7.4534 10.9121,7.3394" id="arrow"></path>            </g>        </g>    </g></svg>'
                }
              }));;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h('div', {
                props: {
                  innerHTML: '<?xml version="1.0" encoding="UTF-8"?><svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Arrow Up</title>    <desc>Smart Hub Icons</desc>    <defs></defs>    <g id="Page-1" stroke="none" stroke-width="1" fill-rule="evenodd">        <g id="Arrow-Up">            <g id="Arrow-Up">                <path d="M8,0 C12.418,0 16,3.582 16,8 C16,12.418 12.418,16 8,16 C3.582,16 0,12.418 0,8 C0,3.582 3.582,0 8,0" id="disc"></path>                <path d="M10.9121,7.3394 L8.4241,4.9214 C8.1901,4.6934 7.8101,4.6934 7.5761,4.9214 L5.0881,7.3394 C4.9711,7.4534 4.9711,7.6384 5.0881,7.7524 L5.5121,8.1644 C5.6291,8.2774 5.8191,8.2774 5.9361,8.1644 L7.4001,6.7414 L7.4001,11.4584 C7.4001,11.6194 7.5341,11.7504 7.7001,11.7504 L8.3001,11.7504 C8.4661,11.7504 8.5991,11.6194 8.5991,11.4584 L8.5991,6.7414 L10.0631,8.1644 C10.1811,8.2774 10.3711,8.2774 10.4881,8.1644 L10.9121,7.7524 C11.0291,7.6384 11.0291,7.4534 10.9121,7.3394" id="arrow"></path>            </g>        </g>    </g></svg>'
                }
              }));;
              return __jade_nodes
            }).call(this)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-sh-alert-header-text': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((alert.anomaly) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("span", {
                "class": {
                  'mp-sh-alert-header-alert-type': true
                },
              }, [__vjadeSafeCode(`Anomaly detected: `)]));;
              return __jade_nodes
            }).call(this)) : (alert.contour) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("span", {
                "class": {
                  'mp-sh-alert-header-alert-type': true
                },
              }, [__vjadeSafeCode(`Interesting segment detected: `)]));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("span", {
              "class": {
                'mp-sh-alert-header-report-type': true
              },
            }, [__vjadeSafeCode($helpers.getReportType())]));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "on": {
              click: ev => $helpers.handleRemoveAlert(ev, alertId)
            },
            "class": {
              'mp-sh-alert-remove': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": {
                icon: 'x'
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-sh-alert-message': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-formatted-message", {
            "attrs": {
              parts: JSON.stringify(message)
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-sh-alert-footer': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-sh-alert-footer-time': true
            },
          }, [__vjadeSafeCode($helpers.getAlertTime())]));
          __jade_nodes = __jade_nodes.concat(($helpers.showFeedback()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-smart-hub-feedback-button", {
              "attrs": {
                'disable': $helpers.isFeedbackDisabled()
              },
              "on": {
                change: $helpers.handleSentFeedback
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "on": {
          click: $helpers.handleClickAlert
        },
        "class": {
          'mp-sh-alert-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((displayContext !== `IN_REPORT`) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("a", {
            "attrs": {
              href: $helpers.generatePermalink()
            },
            "on": {
              click: $helpers.handleClickLink
            },
            "class": Object.assign({}, {
              'mp-sh-alert-unread': !isRead,
            }, {
              'mp-sh-alert-content': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['alert-content'].call(this));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-sh-alert-content': true,
              'mp-sh-alert-in-report': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['alert-content'].call(this));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "alert" in locals ? locals.alert : typeof alert !== "undefined" ? alert : undefined, "alertId" in locals ? locals.alertId : typeof alertId !== "undefined" ? alertId : undefined, "displayContext" in locals ? locals.displayContext : typeof displayContext !== "undefined" ? displayContext : undefined, "isRead" in locals ? locals.isRead : typeof isRead !== "undefined" ? isRead : undefined, "message" in locals ? locals.message : typeof message !== "undefined" ? message : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;